module.exports = __webpack_public_path__ + "assets/img/ZT6240-M.f9be2f43.png";